import React from 'react';
import RouterApp from './config';
import "primereact/resources/themes/lara-light-cyan/theme.css";
import { Provider } from 'react-redux';
import store from './store/store';

function App() {
  return (
    <Provider store={store}>
      <RouterApp />
    </Provider>
  );
}

export default App;
